
import {regionData, CodeToText} from 'element-china-area-data'
import qs from 'qs'
import {areaList} from "@vant/area-data";

export default {
  props: {
    isShowReceipt: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      dialogVisible: false, // 开票类型dialog
      showCompany: false, // 切换到企业发票显示
      showPaper: true, // 切换电子纸质发票切换
      options: regionData,
      totalPrice: 0, // 选择开票金额
      areaList,
      showAddress: false,
      receiptForm: {
        invoice_name: '', // 发票抬头
        open_type: '0', // 开具类型
        invoice_price: 0, // 发票金额
        invoice_type: '0', // 发票类型
        email: '', // 用户邮箱
        taxpayer_identification_number: '', // 纳税人识别号
        bank: '', // 企业开户银行
        enterprise_address: '', // 企业注册地址
        address: [], // 邮寄地址
        addressDetail: '', // 详细地址
        phone_number: '', // 手机号
        invoice_order: [], // 订单号
        select: [],
        enterprise_number: '',
      }, // 发票表单
      selectArea: '', // 选中省市区地址
      receiptRules: {
        invoice_name: [
          {
            required: true,
            message: '请输入发票抬头',
            trigger: 'blur'
          },
        ],
        open_type: [
          {
            required: true,
            message: '请选择开具类型',
            trigger: 'blur'
          },
        ],
        receiptType: [
          {
            required: true,
            message: '请选择开票类型',
            trigger: 'blur'
          },
        ],
        invoice_type: [
          {
            required: true,
            message: '请选择发票类型',
            trigger: 'blur'
          },
        ],
        email: [
          {
            required: true,
            message: '请输入邮箱',
            trigger: 'blur'
          },
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'change']
          }
        ],
        taxpayer_identification_number: [
          {
            required: true,
            message: '请输入纳税人识别号',
            trigger: 'blur'
          },
        ],
        select: [
          {
            required: true,
            message: '请选择邮寄地址地址',
            trigger: 'blur'
          },
        ],
        addressDetail: [
          {
            required: true,
            message: '请输入详细地址',
            trigger: 'blur'
          },
        ],
        phone_number: [
          {
            required: true,
            message: '手机号不能为空',
            trigger: 'blur'
          },
          {
            pattern: /^1[3|4|5|7|8|9]\d{9}$/,
            message: '手机号格式错误'
          }
        ]
      }, // 表单验证规则对象

      tableData1: [], // 订单表格
      selectOrderTable: [], // 选中的订单数组
      receiptType: '1', // 开票类型
      total: '', // 总条数
      pagenum: 1,
      pagesize: 5,
      showLoading: true
    }
  },
  created() {
    this.getSpendRecord() // 消费列表
  },
  methods: {
    onClickLeft(){
      window.history.back()
    },
    // 确定唯一的key值
    getRowKeys(row) {
      return row.id // 每条数据的唯一识别值
    },
    async getSpendRecord() {
      try {
        const {data} = await this.$http.post('/invoice/order', {
          page: this.pagenum,
          pagesize: this.pagesize
        })
        if (data.code == 200) {
          this.showLoading = false
          this.totalPrice = data.data.price
          this.tableData1 = data.data.data
          this.total = data.data.total
        } else {
          this.showLoading = false
          this.$notify({type:'danger',message:data.msg})
        }
      } catch (err) {
        this.showLoading = false
        this.$notify({type:'danger',message:'网络异常,请稍后再试'})
      }
    },

    handleSizeChange(newSize) {
      this.showLoading = true
      this.pagesize = newSize
      this.getSpendRecord()                      // 分页功能
    },

    handleCurrentChange(newPage) {
      this.showLoading = true
      this.pagenum = newPage
      this.getSpendRecord()
    },
    // 选择开票类型事件
    changeRadio(val) {
      this.showCompany = val != '0' // 切换显示个人企业表单
    },
    //  选择订单
    selectOrder(value) {
      this.selectOrderTable = value
      this.receiptForm.invoice_price = this.selectOrderTable.reduce((totalPrice1, item) => {
        return totalPrice1 + parseInt(item.price)
      }, 0)

      let arr = [] // 选中订单数组
      value.forEach(item => {
        arr.push(item.order_number)
        this.receiptForm.invoice_order = arr
      })
    },

    //  发票类型
    changeType(val) {
      this.showPaper = val == '0'
    },

    //  选择省市区
    selectAddress(value) {
      let addressCode = []
      let addressArea = ''
      value.forEach(item=>{
        if(item !== undefined && item.code !== '' && item.name !== ''){
          addressCode.push(item.code)
          addressArea += item.name+'/'
        }
      })
      // 清除末尾 斜线
      addressArea = addressArea.substr(0,addressArea.length-1)
      if(addressCode.length == 3){
        this.receiptForm.select = addressCode
        this.selectArea = addressArea
        this.showAddress = false
      }else{
        this.$notify({type:'warning',message:'请选择完整地址'})
      }
    },

    //  提交表单
    onSubmit() {
      this.receiptForm.address = this.selectArea + this.receiptForm.addressDetail // 邮寄地址
      const cloneForm = {}
      Object.assign(cloneForm, this.receiptForm) // 克隆表单
      delete cloneForm.addressDetail
      delete cloneForm.select
      if (this.selectOrderTable.length === 0) return this.$notify({type:'danger',message:'请选择开票金额'})
      this.$refs.receiptRuleForm.validate(valid => {
        if (valid) {
          // 创建发票
          this.$confirm('请仔细核对发票信息，若信息填写错误，将为您带来不必要的麻烦。', '提示', {
            cancelButtonText: '再核对一下',
            confirmButtonText: '确认提交',
            type: 'warning'
          }).then(async () => {
            const loading = this.$loading({
              lock: true,
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            try {
              const {data} = await this.$http.post('/invoice/add', qs.stringify(cloneForm))
              if (data.code == 200) {
                this.$parent.getReceiptList() // 调用父组件方法重新渲染数据
                loading.close()
                this.$notify({type:'success',message:'开票成功,即将返回发票列表页面'})
                let that = this
                setTimeout(() => {
                  that.$emit(`update:isShowReceipt`, 0) // 通知父组件关闭对话框
                }, 2000)
              } else {
                loading.close()
                this.$notify({type:'danger',message:data.msg})
              }
            } catch (err) {
              loading.close()
              this.$notify({type:'danger',message:'网络异常,请稍后再试'})
            }
          }).catch(() => {

          })

        } else {
          return false
        }
      })
    },
    // 取消提交表单
    cancel() {
      window.history.back()
    }
  }
}
